import React from "react";
import styled from "styled-components";

const Input = styled.input`
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  ::placeholder {
    color: ${({ theme }) => theme.text};
  }
  &:focus {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
  }
  &:disabled {
    background-color: ${({ theme }) =>
      theme.mode === "dark" ? "#4a4a4a99" : "#e9ecef"};
    color: ${({ theme }) => (theme.mode === "dark" ? "#8a8a8a" : theme.text)};
    border-color: ${({ theme }) =>
      theme.mode === "dark" ? "#3a3a3a" : "#dee2e6"};
  }
  &[type="checkbox"],
  &[type="radio"] {
    width: 20px;
    height: 20px;
  }
`;

export default Input;
